export default "__VITE_ASSET__DOSmha_O__"